import { sqliteTable, text, integer, real, index } from "drizzle-orm/sqlite-core";
import { rentalBookings } from "./rental-bookings";
import { vehicles } from "./vehicles";

// ============================================================================
// booking_vehicles — รถแต่ละคันในหนึ่งการจอง
// ============================================================================
export const bookingVehicles = sqliteTable("car_rental_booking_vehicles", {
  id: text("id").primaryKey(), // ULID for new records; deterministic legacy id for backfill
  companyId: text("company_id").notNull(),
  bookingId: text("booking_id").notNull().references(() => rentalBookings.id),
  vehicleId: text("vehicle_id").notNull().references(() => vehicles.id),
  sortOrder: integer("sort_order").notNull().default(0),

  // Pricing snapshot per vehicle line. Booking totals remain on rental_bookings.
  calculationMethod: text("calculation_method", {
    enum: ["24_hour_cycle", "daily"],
  }).notNull().default("daily"),
  rentalDays: integer("rental_days").notNull().default(1),
  dailyRate: real("daily_rate").notNull().default(0),
  rentalAmount: real("rental_amount").notNull().default(0),
  securityDeposit: real("security_deposit").default(0),
  driverRatePerDay: real("driver_rate_per_day").default(0),
  totalDriverCost: real("total_driver_cost").default(0),

  status: text("status", {
    enum: ["active", "cancelled"],
  }).notNull().default("active"),

  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyBookingIdx: index("bv_company_booking_idx").on(table.companyId, table.bookingId),
  companyVehicleIdx: index("bv_company_vehicle_idx").on(table.companyId, table.vehicleId),
  bookingVehicleIdx: index("bv_booking_vehicle_idx").on(table.bookingId, table.vehicleId),
}));

export type BookingVehicle = typeof bookingVehicles.$inferSelect;
export type NewBookingVehicle = typeof bookingVehicles.$inferInsert;
